import { render, staticRenderFns } from "./RisqueForm.vue?vue&type=template&id=550f3c76"
import script from "./RisqueForm.vue?vue&type=script&lang=js"
export * from "./RisqueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports